export default __webpack_public_path__ + "static/media/motivation.1c40858a.svg";